var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeakWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 431,
    height: 54,
    viewBox: "35 293 431 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.796875 0 L 4.796875 -44.21875 L 20.9375 -44.21875 C 23.8125 -44.21875 26.175781 -43.890625 28.03125 -43.234375 C 29.894531 -42.585938 31.367188 -41.6875 32.453125 -40.53125 C 33.546875 -39.382812 34.304688 -38.0625 34.734375 -36.5625 C 35.160156 -35.070312 35.375 -33.507812 35.375 -31.875 C 35.375 -29.414062 34.875 -27.390625 33.875 -25.796875 C 32.875 -24.203125 31.570312 -22.941406 29.96875 -22.015625 C 28.375 -21.097656 26.5625 -20.453125 24.53125 -20.078125 C 22.507812 -19.710938 20.472656 -19.53125 18.421875 -19.53125 L 8.96875 -19.53125 L 8.96875 0 Z M 18.546875 -23.09375 C 20.515625 -23.09375 22.273438 -23.210938 23.828125 -23.453125 C 25.390625 -23.703125 26.710938 -24.164062 27.796875 -24.84375 C 28.878906 -25.519531 29.71875 -26.441406 30.3125 -27.609375 C 30.90625 -28.773438 31.203125 -30.300781 31.203125 -32.1875 C 31.203125 -34.96875 30.289062 -37.070312 28.46875 -38.5 C 26.644531 -39.9375 23.75 -40.65625 19.78125 -40.65625 L 8.96875 -40.65625 L 8.96875 -23.09375 Z M 18.546875 -23.09375 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.96875 0 L 4.96875 -44.21875 L 34.390625 -44.21875 L 34.390625 -40.65625 L 9.15625 -40.65625 L 9.15625 -24.6875 L 31.9375 -24.6875 L 31.9375 -21.125 L 9.15625 -21.125 L 9.15625 -3.5625 L 35.015625 -3.5625 L 35.015625 0 Z M 4.96875 0 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.921875 0 L 18.296875 -44.21875 L 23.03125 -44.21875 L 39.984375 0 L 35.6875 0 L 30.59375 -13.875 L 10.4375 -13.875 L 5.21875 0 Z M 11.859375 -17.4375 L 29.171875 -17.4375 L 20.515625 -40.65625 Z M 11.859375 -17.4375 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.21875 0 L 5.21875 -44.21875 L 9.390625 -44.21875 L 9.390625 -21.3125 L 32.0625 -44.21875 L 36.796875 -44.21875 L 19.34375 -26.59375 L 39.859375 0 L 34.765625 0 L 16.34375 -24.015625 L 9.390625 -17.078125 L 9.390625 0 Z M 5.21875 0 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.984375 -44.21875 L 33.171875 -44.21875 L 33.171875 -40.65625 L 19.15625 -40.65625 L 19.15625 0 L 14.984375 0 L 14.984375 -40.65625 L 0.984375 -40.65625 Z M 0.984375 -44.21875 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.359375 -31.390625 C 35.503906 -35.148438 33.90625 -37.828125 31.5625 -39.421875 C 29.226562 -41.023438 26.179688 -41.828125 22.421875 -41.828125 C 19.753906 -41.828125 17.457031 -41.296875 15.53125 -40.234375 C 13.613281 -39.171875 12.03125 -37.738281 10.78125 -35.9375 C 9.53125 -34.132812 8.609375 -32.054688 8.015625 -29.703125 C 7.421875 -27.347656 7.125 -24.859375 7.125 -22.234375 C 7.125 -19.773438 7.378906 -17.359375 7.890625 -14.984375 C 8.398438 -12.609375 9.25 -10.488281 10.4375 -8.625 C 11.625 -6.757812 13.222656 -5.253906 15.234375 -4.109375 C 17.242188 -2.960938 19.757812 -2.390625 22.78125 -2.390625 C 24.664062 -2.390625 26.382812 -2.695312 27.9375 -3.3125 C 29.5 -3.925781 30.863281 -4.773438 32.03125 -5.859375 C 33.195312 -6.953125 34.175781 -8.234375 34.96875 -9.703125 C 35.769531 -11.179688 36.378906 -12.800781 36.796875 -14.5625 L 41.15625 -14.5625 C 40.664062 -12.425781 39.945312 -10.40625 39 -8.5 C 38.0625 -6.601562 36.820312 -4.9375 35.28125 -3.5 C 33.75 -2.0625 31.882812 -0.921875 29.6875 -0.078125 C 27.5 0.753906 24.929688 1.171875 21.984375 1.171875 C 18.585938 1.171875 15.679688 0.542969 13.265625 -0.703125 C 10.847656 -1.953125 8.867188 -3.640625 7.328125 -5.765625 C 5.796875 -7.898438 4.679688 -10.367188 3.984375 -13.171875 C 3.296875 -15.972656 2.953125 -18.953125 2.953125 -22.109375 C 2.953125 -26.328125 3.472656 -29.910156 4.515625 -32.859375 C 5.554688 -35.804688 7 -38.210938 8.84375 -40.078125 C 10.6875 -41.941406 12.859375 -43.289062 15.359375 -44.125 C 17.859375 -44.96875 20.582031 -45.390625 23.53125 -45.390625 C 25.78125 -45.390625 27.875 -45.09375 29.8125 -44.5 C 31.757812 -43.90625 33.476562 -43.015625 34.96875 -41.828125 C 36.46875 -40.640625 37.695312 -39.175781 38.65625 -37.4375 C 39.625 -35.695312 40.289062 -33.679688 40.65625 -31.390625 Z M 36.359375 -31.390625 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.90625 0 L 4.90625 -44.21875 L 9.09375 -44.21875 L 9.09375 -25.25 L 35.25 -25.25 L 35.25 -44.21875 L 39.4375 -44.21875 L 39.4375 0 L 35.25 0 L 35.25 -21.6875 L 9.09375 -21.6875 L 9.09375 0 Z M 4.90625 0 "
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%, 0%, 0%)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 33.6597,
    y: 342.1172
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 83.46913,
    y: 342.1172
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 133.278561,
    y: 342.1172
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 186.52736,
    y: 342.1172
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 239.776159,
    y: 342.1172
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 269.133628,
    y: 342.1172
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 315.565107,
    y: 342.1172
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-6",
    x: 365.374537,
    y: 342.1172
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-7",
    x: 422.001288,
    y: 342.1172
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeakWordmark);
export default __webpack_public_path__ + "static/media/peak-wordmark.fc7daf62b336f84f3096159938f6226e.svg";
export { ForwardRef as ReactComponent };